// action
import {
    DELETE_EMPLOYEE,
    DELETE_EMPLOYEE_FAIL,
    DELETE_EMPLOYEE_SUCCESS,
    DELETE_EMPLOYEE_RESET
} from '../action/deleteEmployeeAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_EMPLOYEE:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_EMPLOYEE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_EMPLOYEE_RESET:
            return initialState
        default:
            return state
    }
}